export const SOURCE = {
  VISTA: 'vista',
  VISTA_MY_PROJECTS: 'vista_my_projects',
  BRAND_KIT: 'brand_kit',
  LOGOMAKER_EMAIL: 'logomaker_email',
  LOGO_EDITED: 'edit_logo',
  VISTA_LOGOS: 'vista_logos',
  FREE_LOGOMAKER_LOGO_EMAIL: 'logomaker_email_free',
  BRAND_BUILDER: 'brand_builder',
  LOGO_UPLOADER: 'logo_uploader',
}

export const BRAND_SHOP_OFFERINGS = {
  TRY_THE_BEST: 'TRY_THE_BEST',
  YELP: 'YELP',
  PRINT: 'PRINT',
  DOMAIN: 'DOMAIN',
  DESIGN: 'DESIGN',
  DING: 'DING',
  LEGAL_ZOOM: 'LEGAL_ZOOM',
  WIX_WEBSITES: 'WIX_WEBSITES',
}

export enum DOMAIN_WIDGET {
  REVIEW_AND_BUY = 'ReviewAndBuy',
  EXPLORE_DOMAINS = 'ExploreDomains',
  CONNECT_OWN_DOMAIN = 'ConnectOwnDomain',
}

export enum WEBSITE_WIDGET {
  GET_STARTED = 'Get Started Website',
  PRIVACY_POLICY = 'Privacy Policy Website',
  TERMS_OF_USE = 'Terms Of Use Website',
}

export enum YELP_WIDGET {
  CLAIM_PAGE = 'Claim your free Yelp page',
}

export enum LEGALZOOM_WIDGET {
  START_MY_LLC = 'Start my LLC',
  IS_LLC_RIGHT_FOR_ME = 'Is LLC right for me',
}
export enum TRY_THE_BEST_WIDGET {
  SHOP_NOW = 'Shop Now',
}
